<ng-template #cellRendererTmpl let-record="record" let-column="column">
  <!-- uncomment to have compiler check template types
  <ng-container *ngIf="typedRecord(record); let record">
  <ng-container *ngIf="typedColumn(column); let column">
  -->
  <ng-container [ngSwitch]="column.name">

    <td *ngSwitchCase="'modifiedAt'">
      <div>{{ record.modifiedAt | date: "yyyy-MM-dd HH:mm:ss" }}</div>
      <div class="text-secondary font-italic small">
        {{ record.modifiedByName }}
      </div>
    </td>

    <td *ngSwitchCase="'statusName'" [ngClass]="record.status|taskStatusCss">
      <div *ngIf="taskTable.savingStatusTaskId===record.id" class="text-center">
        <i class="fa fa-spinner fa-spin mr-2" ></i>
        <span class="font-italic text-secondary">saving...</span>
      </div>
      <select id="status-select" class="text-center align-middle"
        [ngClass]="taskTable.savingStatusTaskId===record.id?'d-none':record.status|taskStatusCss"
        *ngIf="record" [ngModel]="record.status" (change)="taskTable.onTaskStatusChange(record,$event.target)">
        <option  class="status-not-started-text" value="1">Not Started</option>
        <option class="status-in-progress-text" value="2">In Progress</option>
        <option class="status-approved-text" value="3">Complete</option>
        <option class="status-field-complete-text" value="4">Field Complete</option>
        <option [hidden]="!this.roleMgr.canEditUsers" class="status-review-complete-text" value="5">Review Complete</option>
        <option [hidden]="!this.roleMgr.canEditUsers" class="status-not-using-text" value="6">Not Using</option>
        <option [hidden]="!this.roleMgr.canEditUsers" class="status-archived-text" value="7">Archived</option>
      </select>
    </td>

    <td *ngSwitchCase="'buildingId'">
      <a href="javascript:false" (click)="taskTable.showBuilding(record)">{{
        record.buildingId
      }}</a>
    </td>

    <td *ngSwitchCase="'buildingName'">
      <a href="javascript:false" (click)="taskTable.showBuilding(record)">{{
        record.buildingName
      }}</a>
    </td>

    <td *ngSwitchCase="'lastCallStartTime'">
      <a href="javascript:false;" (click)="taskTable.showCallLog(record)">
        {{ record[column.name]  | date: "yyyy-MM-dd HH:mm"}}
      </a>
    </td>

    <td *ngSwitchCase="'seriesPosition'" class="text-center">
        {{ record[column.name] }}
        <ng-container *ngIf="record.seriesMaxCnt"> / {{record.seriesMaxCnt}}</ng-container>
    </td>

    <td *ngSwitchCase="'taskPoints'">
      <div *ngIf="record.taskPoints?.length" class="d-flex flex-wrap">
        <a *ngFor="let vpt of record.taskPoints"
          href="javascript:false"
          (click)="taskTable.showVolunteerPoint(record,vpt)"
          class="mr-1 text-nowrap"
          [ngClass]="record.lastActiveTaskPointId == vpt.id && 'font-weight-bold'"
          >{{ vpt.pointId || '(missing point id)'}}</a
        >
      </div>
    </td>


    <td *ngSwitchCase="'testSummary'" [ngClass]="column.template=='testSummary'&&'test-summary-cell'">
      <table *ngIf="record.taskPoints?.length"
        class="table table-sm table-compact test-summary-table"
      >
        <tr class="points-header-row">
          <th>Point</th><th>Name</th><th>Calls</th><th>Last Call Time</th>
        </tr>
        <tr *ngFor="let tp of record.taskPoints;">
          <td>{{tp.pointId}}</td>
          <td>{{tp.commonName}}</td>
          <td>{{tp.callsPlacedCnt}}</td>
          <td>{{tp.lastCallTime|date:'yyyy-MM-dd HH:mm:ss z'}}</td>
        </tr>
      </table>
    </td>

    <td *ngSwitchCase="'callsCompletePct'" class="text-center">
      {{record[column.name] | number: "1.0-2" }}%
    </td>

    <!-- did not find a cell renderer by column name so now try template type -->
    <ng-container *ngSwitchDefault [ngSwitch]="column.template">
      <td *ngSwitchCase="'volunteerLink'">
        <div style="line-height: 1.2">
          <div *ngIf="!roleMgr.canEditUsers; else editableAssignedUser">
            {{ record[column.name] }}
          </div>
          <ng-template #editableAssignedUser>
            <a
            (click)="taskTable.onShowAssignedUserAction(record)"
            href="javascript:false;"
            >
          {{ record[column.name] }}
          </a>
          </ng-template>
          <div *ngIf="column.name==='volunteerName'" class="text-secondary font-italic small">
            {{record.volunteerId}}
          </div>
        </div>
      </td>
      <td *ngSwitchCase="'hours'" class="text-center">
        {{record[column.name] | duration:'hours'}}
      </td>
      <td *ngSwitchCase="'edit-task'" class="text-center">
        <div class="flex flex-row">
          <a
            class="mr-1"
            href="javascript:false;"
            (click)="taskTable.showVolunteerTask(record)"
            >edit</a
          >
          <div class="btn-group p-0 m-0" dropdown container="body">
            <a
              id="edit-options-btn"
              href="javascript:false;"
              behavior="button"
              dropdownToggle
              class="dropdown-toggle"
              aria-controls="dropdown-edit-options"
            >
              <span class="caret"></span>
            </a>
            <ul
              style="z-index: 9999999; min-width: 3rem"
              id="dropdown-edit-options"
              *dropdownMenu
              class="p-2 dropdown-menu dropdown-menu-right"
              role="menu"
              aria-labelledby="edit-options-btn"
            >
              <li role="menuitem" *ngFor="let action of taskTable.singleRowActions;"
              style="margin-bottom:2px;">
                <button
                  class="btn btn-secondary w-100 text-left text-nowrap" style="border-radius: 0;"
                  [ngClass]="action.cssClass"
                  (click)="doAction(action,record)"
                >
                  {{action.title}}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </td>

      <td
        *ngSwitchDefault
        fes-table-view-default-cell-renderer
        [column]="column"
        [record]="record"
        [tableComponent]="taskTable"
      ></td>
    </ng-container>
  </ng-container>

  <!--
  </ng-container></ng-container>
  -->
</ng-template>

<ng-template #editColumnHeaderTmplRef let-column="column">
  <th style="position: sticky;
  top: -2px;
  z-index:10;
  margin:0;
  box-shadow: 0 0 0 1px white;">
    <div class="d-flex flex-column">
      <button
        class="btn btn-secondary text-nowrap"
        (click)="taskTable.onEditVolunteerTask(null)"
      >
        <i class="fa fa-plus-square"></i> new
      </button>
    </div>
  </th>
</ng-template>

<div class="d-flex flex-row mb-1" *ngIf="groupedTotalCalls"
    style="max-width:100%;overflow-x: auto;">
  <div>
    <table *fesListView="let gtc of groupedTotalCalls.totalCalls"
      class="m-0 p-0 table table-sm table-striped table-bordered" style="height:1px;">
      <!-- horizontal table view of grouped call count stats -->
      <ng-container *ngIf="horizontalGroupings">
      <thead>
        <tr>
          <th [attr.title]="groupedTotalCalls.groupName">
            <div class="d-flex flex-row">
              <app-filter-field-config>
              <input type="text" class="w-100" size="12" style="min-width:8em" fesFilterField="groupKey"/>
              </app-filter-field-config>
              <div fesSortField="groupKey" [sort]="'asc'" title="sort" class="my-auto ml-1 p-1 border rounded"
                style="min-width:2em;">
                <i class="fa fa-sort"></i>
              </div>
            </div>
          </th>
          <th *ngFor="let totalCallsGrp of gtc">{{totalCallsGrp.groupKey}}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th title="Name">
            <div class="d-flex flex-row">
              <app-filter-field-config>
              <input type="text" class="w-100" size="12" style="min-width:8em" fesFilterField="title"/>
              </app-filter-field-config>
              <div fesSortField="title" title="sort" class="my-auto ml-1 p-1 border rounded"
                style="min-width:2em;">
                <i class="fa fa-sort"></i>
              </div>
            </div>
          </th>
          <th *ngFor="let totalCallsGrp of gtc" class="small font-italic">{{totalCallsGrp.title}}</th>
        </tr>
        <!--tr>
          <th fesSortField="targetTotalCalls" [sortType]="'numeric'">Target</th>
          <td *ngFor="let totalCallsGrp of gtc">{{totalCallsGrp.targetTotalCalls}}</td>
        </tr-->
        <tr>
          <th fesSortField="totalMissingCalls" [sortType]="'numeric'" title="Calls assigned but not placed">Missing</th>
          <td *ngFor="let totalCallsGrp of gtc">{{totalCallsGrp.totalMissingCalls}}</td>
        </tr>
        <tr>
          <th fesSortField="totalCalls" [sortType]="'numeric'" title="Calls complete">Complete</th>
          <td *ngFor="let totalCallsGrp of gtc">{{totalCallsGrp.totalCalls}}</td>
        </tr>
        <tr>
          <th fesSortField="callsCompletePct" [sortType]="'numeric'" title="Call completion">Complete %</th>
          <td *ngFor="let totalCallsGrp of gtc">{{totalCallsGrp.callsCompletePct|number:'1.0-2'}}%</td>
        </tr>
        <tr>
          <th class="d-flex flex-row justify-content-between">
            <div class="mr-2 py-1" title="Task count by status (hover over sort buttons for color mapping)">
              Tasks
            </div>
            <div class="d-flex flex-row">
            <div fesSortField="nextEndDate"
              title="Next Task End Date (if active)"
              class="btn btn-small mr-1 border">
              <div class="d-flex flex-column justify-content-center h-100">
               <i class="far fa-hourglass text-white"></i>
              </div>
            </div>
            <div fesSortField="notStarted" [sortType]="'numeric'"
                title="Not Started Count"
                class="btn btn-small status-not-started mr-1 border text-center">
                <div class="d-flex flex-column justify-content-center h-100">
                  <i class="fa fa-arrows-alt-v text-secondary"></i>
                 </div>
            </div>
            <div fesSortField="inProgress" [sortType]="'numeric'"
                title="In Progress Count"
                class="btn btn-small status-in-progress mr-1 border">
                <div class="d-flex flex-column justify-content-center h-100">
                  <i class="fa fa-arrows-alt-v text-secondary"></i>
                 </div>
            </div>
            <div fesSortField="complete" [sortType]="'numeric'"
                title="Complete Count"
                class="btn btn-small status-complete mr-1 border">
                <div class="d-flex flex-column justify-content-center h-100">
                  <i class="fa fa-arrows-alt-v text-secondary"></i>
                 </div>
            </div>
            <div fesSortField="fieldComplete" [sortType]="'numeric'"
                title="Field Complete Count"
                class="btn btn-small status-field-complete mr-1 border">
                <div class="d-flex flex-column justify-content-center h-100">
                  <i class="fa fa-arrows-alt-v text-secondary"></i>
                 </div>
            </div>
          </div>
          </th>
          <td *ngFor="let totalCallsGrp of gtc"
            class="m-0 p-0 align-middle"
            [attr.title]="totalCallsGrp.nextEndDate&&('Next task ending '+(totalCallsGrp.nextEndDate|date:'medium'))||'No Active Tasks'">
            <div *ngLet="(totalCallsGrp.notStarted+totalCallsGrp.inProgress+totalCallsGrp.complete+totalCallsGrp.fieldComplete) as statusTotal"
              class="d-flex flex-row w-100 h-100 text-center font-italic text-secondary" style="border: solid 2px gray;">
              <div *ngIf="totalCallsGrp.notStarted"
                class='d-flex flex-column justify-content-center status-not-started'
                [style.width]="100*totalCallsGrp.notStarted/statusTotal+'%'">
                {{totalCallsGrp.notStarted}}
              </div>
              <div *ngIf="totalCallsGrp.inProgress"
                class='d-flex flex-column justify-content-center status-in-progress'
                [style.width]="100*totalCallsGrp.inProgress/statusTotal+'%'">
                {{totalCallsGrp.inProgress}}
              </div>
              <div *ngIf="totalCallsGrp.complete"
                class='d-flex flex-column justify-content-center status-complete'
                [style.width]="100*totalCallsGrp.complete/statusTotal+'%'">
                {{totalCallsGrp.complete}}
              </div>
              <div *ngIf="totalCallsGrp.fieldComplete"
                class='d-flex flex-column justify-content-center status-field-complete'
                [style.width]="100*totalCallsGrp.fieldComplete/statusTotal+'%'">
                {{totalCallsGrp.fieldComplete}}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      </ng-container>

      <!-- vertical table view of grouped call count stats -->
      <ng-container *ngIf="!horizontalGroupings">
        <thead>
          <tr>
            <th colspan="2">
              <div class="d-flex flex-row">
              <button *ngIf="groupedTotalCalls"
              title="Switch to horizontal count table layout"
              class="btn btn-secondary btn-small" (click)="horizontalGroupings=!horizontalGroupings">
                <i class="fa fa-table mr-1"></i>
                <i class="fa" [ngClass]="horizontalGroupings?'fa-angle-right':'fa-angle-down'">
                </i>
              </button>
              <div class="w-100 text-center">
                {{groupedTotalCalls.groupName}}
              </div>
              </div>
            </th>
            <th colspan="4" class="text-center">Call Counts</th>
            <th colspan="5" class="text-center">Task Status</th>
          </tr>
          <tr>
            <th fesSortField="groupKey" [sort]="'asc'">ID</th>
            <th fesSortField="title">Name</th>
            <th fesSortField="totalMissingCalls" [sortType]="'numeric'">Missing</th>
            <th fesSortField="totalCalls" [sortType]="'numeric'">Complete</th>
            <th fesSortField="targetTotalCalls" [sortType]="'numeric'">Assigned</th>
            <th fesSortField="callsCompletePct" [sortType]="'numeric'">Complete %</th>
            <th fesSortField="notStarted" [sortType]="'numeric'">Not Started</th>
            <th fesSortField="inProgress" [sortType]="'numeric'">In Progress</th>
            <th fesSortField="complete" [sortType]="'numeric'">Complete</th>
            <th fesSortField="fieldComplete" [sortType]="'numeric'">Field Complete</th>
            <th fesSortField="nextEndDate">Next Task End</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <app-filter-field-config>
                <input type="text" class="w-100" size="10" fesFilterField="groupKey"/>
                </app-filter-field-config>
            </td>
            <td>
              <app-filter-field-config>
                <input type="text" class="w-100" size="16" fesFilterField="title"/>
                </app-filter-field-config>
            </td>
            <td>
              <app-filter-field-config>
                <input type="text" class="w-100" size="3" fesFilterField="missingCalls" [filterType]="'numeric'"/>
                </app-filter-field-config>
            </td>
            <td>
              <app-filter-field-config>
                <input type="text" class="w-100" size="3" fesFilterField="totalCalls" [filterType]="'numeric'"/>
                </app-filter-field-config>
            </td>
            <td>
              <app-filter-field-config>
                <input type="text" class="w-100" size="3" fesFilterField="targetTotalCalls" [filterType]="'numeric'"/>
                </app-filter-field-config>
            </td>
            <td>
              <app-filter-field-config>
                <input type="text" class="w-100" size="3" fesFilterField="callsCompletePct" [filterType]="'numeric'"/>
                </app-filter-field-config>
            </td>
            <td>
              <app-filter-field-config>
                <input type="text" class="w-100" size="3" fesFilterField="notStarted" [filterType]="'numeric'"/>
                </app-filter-field-config>
            </td>
            <td>
              <app-filter-field-config>
                <input type="text" class="w-100" size="3" fesFilterField="inProgress" [filterType]="'numeric'"/>
                </app-filter-field-config>
            </td>
            <td>
              <app-filter-field-config>
                <input type="text" class="w-100" size="3" fesFilterField="complete" [filterType]="'numeric'"/>
                </app-filter-field-config>
            </td>
            <td>
              <app-filter-field-config>
                <input type="text" class="w-100" size="3" fesFilterField="fieldComplete" [filterType]="'numeric'"/>
                </app-filter-field-config>
            </td>
            <td>
              <app-filter-field-config>
                <input type="text" class="w-100" size="3" fesFilterField="nextEndDate"/>
                </app-filter-field-config>
            </td>
          </tr>
          <tr *ngFor="let totalCallsGrp of gtc">
            <td>{{totalCallsGrp.groupKey}}</td>
            <td>{{totalCallsGrp.title}}</td>
            <td>{{totalCallsGrp.totalMissingCalls}}</td>
            <td>{{totalCallsGrp.totalCalls}}</td>
            <td>{{totalCallsGrp.targetTotalCalls}}</td>
            <td>{{totalCallsGrp.callsCompletePct|number:'1.0-2'}}%</td>
            <td>{{totalCallsGrp.notStarted}}</td>
            <td>{{totalCallsGrp.inProgress}}</td>
            <td>{{totalCallsGrp.complete}}</td>
            <td>{{totalCallsGrp.fieldComplete}}</td>
            <td>{{totalCallsGrp.nextEndDate|date:'medium'}}</td>
          </tr>
        </tbody>
        </ng-container>

    </table>
  </div>
</div>

<app-volunteer-tasks-table
  [cellRendererTmplRef]="cellRendererTmpl"
  [editColumnHeaderTmplRef]="editColumnHeaderTmplRef"
  [tabConfig]="tabConfig"
  [detailFn]="detailFn"
  [isActiveView]="tabConfig.active"
  [contextJson]="tabConfig.viewInfo.id"
  (contextJsonChange)="contextJsonChangeHandler($event, tabConfig)"
  (queryResp)="onTableResponse($event)"
  #volunteerTasksTable
>
  <div class="d-flex flex-row mb-1" *ngIf="totalCalls">
    <table class="m-0 mr-2 p-0 table table-sm table-striped table-bordered">
      <thead>
        <tr>
          <th>Target</th>
          <th>Complete</th>
          <th>Missing</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-center">{{totalCalls.targetTotalCalls}}</td>
          <td class="text-center">{{totalCalls.totalCalls}} ({{totalCalls.callsCompletePct|number:'1.0-2'}}%)</td>
          <td class="text-center">{{totalCalls.totalMissingCalls}}</td>
        </tr>
      </tbody>
    </table>
    <table class="m-0 p-0 table table-sm table-striped table-bordered">
      <thead>
        <tr>
          <th class="text-nowrap">Not Started</th>
          <th class="text-nowrap">In Progress</th>
          <th>Complete</th>
          <th class="text-nowrap">Field Complete</th>
          <!--th>Next End Date</th-->
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-center">{{totalCalls.notStarted}}</td>
          <td class="text-center">{{totalCalls.inProgress}}</td>
          <td class="text-center">{{totalCalls.complete}}</td>
          <td class="text-center">{{totalCalls.fieldComplete}}</td>
          <!--td class="text-center">{{totalCalls.nextEndDate|date:'short'}}</td-->
        </tr>
      </tbody>
    </table>
  </div>
  <button *ngIf="groupedTotalCalls"
      title="Toggle horizontal/vertical count table layout"
      class="btn btn-secondary btn-small" (click)="horizontalGroupings=!horizontalGroupings">
      <i class="fa fa-table mr-1"></i>
      <i class="fa" [ngClass]="horizontalGroupings?'fa-angle-right':'fa-angle-down'">
    </i>
  </button>

</app-volunteer-tasks-table>
